<div class="input-wrapper">
	<input
		[type]="InputType.Number"
		[(ngModel)]="params.value"
		(input)="pushChangesGridInput($event.target.value)"
		(keydown)="onKeyDown($event)"
		[disabled]="isDisabled"
	/>
</div>
